import en from './en.json';
import ru from './ru.json';
import { i18n } from 'locales';

i18n.addResourceBundle('en', 'inventory', en, true);
i18n.addResourceBundle('ru', 'inventory', ru, true);
